import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { CustomButton } from 'src/components/ui'

import styles from './Nothing.module.scss'

const Nothing = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.wrapper}>
        <h1>{t('history_participations.nothing.title')}</h1>
        <p>{t('history_participations.nothing.subtitle')}</p>
      </div>

      <CustomButton className={styles.btn} onClick={() => navigate('/bottles')} variant='contained' color='violet'>
        {t('history_participations.nothing.show_bank')}
      </CustomButton>
    </>
  )
}

export default Nothing
